import { teamAadharDetailsActions } from "./action";

const initialState = {
  aadhareamVerify: null,
};

const saveAadharNumTeamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case teamAadharDetailsActions.SAVE_TEAMS_AADHAR_DETAILS_ERROR:
      return {
        ...state,
        aadhareamVerify: [],
      };
    case teamAadharDetailsActions.SAVE_TEAMS_AADHAR_DETAILS_SUCCESS:
      return {
        ...state,
        aadhareamVerify: action.payload.data,
      };

    default:
      return state;
  }
};

export default saveAadharNumTeamsReducer;
